const s = {
  name: "MilanCathedral",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,34v4h2v-4H19z"/>
		<path class="st0" d="M19,30v-4h2v4H19z"/>
		<path class="st0" d="M19,18v4h2v-4H19z"/>
		<path class="st0" d="M33,34v4h2v-4H33z"/>
		<path class="st0" d="M33,26v4h2v-4H33z"/>
		<path class="st0" d="M5,38v-4h2v4H5z"/>
		<path class="st0" d="M5,30v-4h2v4H5z"/>
		<path class="st0" d="M26,4v7h2V4h2v11.6l3,3V13h2v7.6l3,3V18h2v22H0V18h2v5.6l3-3V13h2v5.6l3-3V4h2v7h2V4h2v5.6l3-3V0h2v6.6l3,3V4
			H26z M26,13v25h2V13H26z M24,12.4l-4-4l-4,4V38h8V12.4z M30,18.4V38h8V26.4L30,18.4z M14,38V13h-2v25H14z M10,18.4l-8,8V38h8V18.4
			z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as MilanCathedral
};
